<template>
  <div>
    <b-container class="text-left" v-if="newsItem != null">
      <h1 class="text-left mt-2 mb-2">{{ newsItem.name }}</h1>
      <br />
      <small>{{ newsDate(newsItem.releaseDate) }}</small>
      <br /><br />
      <p>{{ newsItem.lead }}</p>
      <br />
      <img :src="newsItem.image" v-if="newsItem.image" class="mx-auto" style="max-width: 100%" />
      <p v-if="newsItem.imageSource" class="small">A kép forrása: {{ newsItem.imageSource }}</p>
      <div v-html="newsItem.body" class="mt-5 news-body-content"></div>
      <br />
      <p v-if="newsItem.source">Forrás: {{ newsItem.source }}</p>
    </b-container>
  </div>
</template>

<script>
import { getNewsItemBySeq } from '../../api/news'
export default {
  name: 'NewsDetails',
  data() {
    return {
      newsItem: null
    }
  },
  async mounted() {
    const newsId = this.$route.params.id

    this.$gtag.event('user_news_details', {
      event_category: 'user_interaction',
      news_id: newsId
    })

    if (!newsId) this.$router.push('/')
    try {
      this.newsItem = await getNewsItemBySeq(newsId)
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    newsDate(date) {
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(date).toLocaleDateString('hu-HU', options)
    }
  }
}
</script>

<style scoped>
::v-deep p {
  margin-bottom: 0rem !important;
}

::v-deep .ql-video {
  display: block;
  width: 70%;
  height: 56.25vw;
  max-height: calc(800px / 16 * 9);
}

::v-deep .news-body-content img {
  max-width: 100%;
  width: auto;
  height: auto;
}
</style>
